import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { Injectable } from '@angular/core';
import { CompressedModel } from '../models/compressed.model';
import { FileModel, ConfigFile } from '../models/global/class.global';
import { mergeMap, catchError, map } from 'rxjs/operators';
import * as FileSaver from 'file-saver';


/**
 * require pour lib externe
 */
declare var require: any;
/**
 * Importation librairie pako (compresseur)
 */
const pako: any = require('pako');

@Injectable({
  providedIn: 'root'
})

export class HttpService {

  constructor(
    protected http: HttpClient
  ) { }

  getText(url: string): Observable<string> {
    const urlBase: string = `${url}`;
    return this.http.get(urlBase, { responseType: 'text' });
  }

  getHttp<T>(url: string, options: {headers: HttpHeaders} | null = null): Observable<T> {
    const urlBase: string = `${url}`;
    if (options == null) {
      return this.http.get<T>(urlBase);
    } else {
      return this.http.get<T>(urlBase, options);
    }
  }

  postHttp<T>(url: string, model: any): Observable<T> {
    const urlBase: string = `${url}`;
    return this.http.post<T>(urlBase, model);
  }

  deleteHttp<T>(url: string, options: { headers: HttpHeaders } | null = null): Observable<T> {
    const urlBase: string = `${url}`;
    if (!options) {
      options = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
        })
      };
    } else {
      options.headers.append('Content-Type', 'application/json');
    }    
    return this.http.delete<T>(urlBase,options);
  }

  patchHttp<T>(url: string, model: any): Observable<T> {
    const urlBase: string = `${url}`;
    return this.http.patch<T>(urlBase, model);
  }

  upload(urlRoute: string, formData: FormData): Observable<any> {
    const config: any = {
      responseType: 'arraybuffer' as 'arraybuffer'
    };
    return this.http.post(urlRoute, formData, config);
  }

  download(urlRoute: string, fileModel: FileModel): Observable<any> {
    const config: any = {
      responseType: 'arraybuffer' as 'arraybuffer'
    };

    return this.http.post(urlRoute, fileModel, config);
  }
 
  postHttpCompressed<T>(apiUrl: string, apiPath: string, model: T): Observable<T> {
    const headerscnt: HttpHeaders = new HttpHeaders().set('Content-Type', 'application/json');
    headerscnt.set('Content-Encoding', 'gzip');
   // const binaryString: any = pako.deflate(JSON.stringify(model), { to: 'string' });
    const binaryString: any = pako.gzip(JSON.stringify(model));
    const byteArray: Array<number> = Array.from(binaryString);
    // Construction du modèle compressé (avec urlBase stockée dans le modèle si besoin)
    const compressModel: CompressedModel = new CompressedModel();
    compressModel.ApiPath = apiPath;
    compressModel.ObjectCompressed = JSON.stringify(byteArray);

    // test taille
    const size: number = (new TextEncoder().encode(compressModel.ObjectCompressed)).length;

    // Définition de l'url du controller spécifique
    const urlApiCompressed: string = `${apiUrl}api/compress/`;
    return this.http.post<T>(urlApiCompressed, compressModel);
  }

  getFileConfig(fileConfigPath: string): Observable<ConfigFile | null> {
    return this.http.get<ConfigFile>(fileConfigPath).pipe(mergeMap((conf: ConfigFile) => {
      return of(conf);
    }), catchError((error: Error) => {
      console.error(JSON.stringify(error));
      return of(null);
    }));
  }
}
